@if (requiredAppDescriptions$ | async; as requiredAppDescriptions) {
  <ul class="requirements-list">
    @for (requiredAppDescription of requiredAppDescriptions; track requiredAppDescription) {
      <li class="required-app-list-item">
        <a [routerLink]="requiredAppDescription.redirectURL">
          {{ requiredAppDescription.name }}
        </a>
      </li>
    }
  </ul>
} @else {
  @for (n of [1, 2, 3]; track n) {
    <div class="stencil-item stencil-shimmer"></div>
  }
}
